import Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import JournalGroupModel from 'donor-elf-web/models/all-funds/journal-group';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export interface JournalGroupRouteModel {
  journalGroup: JournalGroupModel;
}

export default class JournalGroupRoute extends Route {
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;

  async model(params: { id: string }): Promise<JournalGroupRouteModel> {
    let journalGroup = undefined;
    if (params.id === 'new') {
      journalGroup = this.store.createRecord('all-funds/journal-group');
      this.navbarSettings.title = 'Add Journal Group';
    } else {
      journalGroup = await this.store.findRecord(
        'all-funds/journal-group',
        params.id,
      );
      this.navbarSettings.title = journalGroup.name;
    }

    return {
      journalGroup,
    };
  }
}
